export default __webpack_public_path__ + "static/media/muster.0232f1a1.png";